export function showStartupError(): void {
    document.body.classList.add('fuse-splash-screen-hidden');

    const panel = document.createElement('div');
    panel.className = 'tms-startup-error';
    panel.innerHTML = `
        <div class="tms-startup-error__content">
            <h1 class="tms-startup-error__title">Something went wrong</h1>
            <p class="tms-startup-error__message">Dante TMS could not start. Please reload and try again.</p>
            <button type="button" class="tms-startup-error__button">Reload</button>
        </div>
    `;
    panel.querySelector('.tms-startup-error__button')?.addEventListener('click', () => location.reload());
    document.body.appendChild(panel);
}
